<script setup lang="ts">
import { computed, ref } from 'vue'
import type ContextMenuItem from '../../../type/ContextMenuItem'
import ContextMenuItemView from './ContextMenuItemView.vue'

const { menuGroups, obj, theme } = defineProps({
  menuGroups: {
    type: Array<Array<ContextMenuItem>>,
    required: true
  },
  obj: {
    type: Object,
    required: false
  },
  theme: {
    type: Boolean,
    required: false,
    default: false
  }
})

let menuToRender = computed(() => {
  const menuOrdered = new Array<Array<ContextMenuItem>>()
  for (let i = 0; i < menuGroups.length; i++) {
    const group = menuGroups[i]
    if (i === 0 && group.length > 0) {
      group[0].isTop = false
      if (menuGroups.length > 1) {
        group[group.length - 1].isBottom = true
      }
    } else if (i === menuGroups.length - 1) {
      group[0].isTop = true
      group[group.length - 1].isBottom = false
    } else if (group[0]) {
      group[0].isTop = true
      group[group.length - 1].isBottom = true
    }
    menuOrdered.push(group)
  }
  return menuOrdered
})

let popper = ref()

const emit = defineEmits(['onItemClicked', 'visibleChanged'])

function handleClicked(item: ContextMenuItem) {
  console.log('选择了？')
  emit('onItemClicked', item, obj)
  popper.value?.hide()
}

function visibilityChanged(isVisible: boolean) {
  emit('visibleChanged', isVisible)
}
</script>
<template>
  <el-popover
    v-if="menuGroups?.length > 0"
    ref="popper"
    placement="bottom"
    :width="90"
    trigger="click"
    :hide-after="50"
    :aria-hidden="false"
    :popper-style="{ 'z-index': 3026, padding: '8px 0px' }"
    :teleported="true"
    @show="visibilityChanged(true)"
    @hide="visibilityChanged(false)">
    <template #reference>
      <slot name="trigger"></slot>
    </template>
    <template v-for="(group, index) in menuToRender" :key="index">
      <ContextMenuItemView
        v-for="(item, index) in group"
        role="menuitem"
        :key="index"
        :menuItem="item"
        @click="handleClicked(item)"
        :theme="theme">
      </ContextMenuItemView>
    </template>
  </el-popover>
</template>
<style></style>
